/**
 * Communications sub-page for the unified move view.
 * Renders the communications log + form for logging customer interactions,
 * as its own routed page at /moves/:quoteId/activity.
 *
 * On mobile: shows a back button (since the shell left panel is hidden).
 * On desktop (md+): renders directly in the shell's right panel.
 */
import { useNavigate } from 'react-router-dom';
import { ArrowLeft } from 'lucide-react';
import { useSharedQuote } from '../../context/QuoteContext';
import { LeadCommunicationsTab } from './MovePageComponents';

export function MoveActivityPage() {
  const navigate = useNavigate();
  const { quote, updateQuote } = useSharedQuote();

  return (
    <div className="px-4 pt-4 pb-8">
      {/* Mobile back button — hidden on md+ where the shell left panel provides navigation */}
      <button type="button" onClick={() => navigate(-1)}
        className="md:hidden flex items-center gap-1 text-small text-slate hover:text-midnight mb-4
                   transition-colors duration-150 -ml-1">
        <ArrowLeft size={16} />
        Back
      </button>

      <h1 className="font-display text-h3 text-midnight mb-4">Communications</h1>

      <LeadCommunicationsTab quote={quote!} updateQuote={updateQuote} />
    </div>
  );
}
